import { IMPACT_METRICS, ImpactMetricKey } from "@/pages/dashboard/utils/types";
import { useCompanySettings } from "./useCompanySettings";

export type ImpactMethod = "ReCiPe 2016 v1.03, midpoint (H)" | "EF v3.1";

export default function useImpactMethod() {
  const { data: companySettings, isLoading } = useCompanySettings();

  const impactMethod = companySettings?.impact_method;

  const environmentalCostMetric: ImpactMetricKey =
    impactMethod === "EF v3.1" ? "ef_environmental_cost" : "environmental_cost";

  const indicators =
    impactMethod === "EF v3.1"
      ? Object.values(IMPACT_METRICS).filter((x) =>
          [
            "carbon_footprint",
            "ef_environmental_cost",
            "ef_acidification",
            "ef_climate_change",
            "ef_climate_change_biogenic",
            "ef_climate_change_fossil",
            "ef_climate_change_land_use_and_land_use_change",
            "ef_ecotoxicity_freshwater",
            "ef_ecotoxicity_freshwater_inorganics",
            "ef_ecotoxicity_freshwater_organics",
            "ef_energy_resources_non_renewable",
            "ef_eutrophication_freshwater",
            "ef_eutrophication_marine",
            "ef_eutrophication_terrestrial",
            "ef_human_toxicity_carcinogenic",
            "ef_human_toxicity_carcinogenic_inorganics",
            "ef_human_toxicity_carcinogenic_organics",
            "ef_human_toxicity_non_carcinogenic",
            "ef_human_toxicity_non_carcinogenic_inorganics",
            "ef_human_toxicity_non_carcinogenic_organics",
            "ef_ionising_radiation_human_health",
            "ef_land_use",
            "ef_material_resources_metals_minerals",
            "ef_ozone_depletion",
            "ef_particulate_matter_formation",
            "ef_photochemical_oxidant_formation_human_health",
            "ef_water_use",
            "ef_resource_scarcity",
          ].includes(x.key)
        )
      : Object.values(IMPACT_METRICS).filter((x) =>
          [
            "carbon_footprint",
            "environmental_cost",
            "human_health",
            "terrestrial_ecosystems",
            "marine_ecosystems",
            "freshwater_ecosystems",
            "ecosystems",
            "water_use",
            "acidification",
            "climate_change",
            "toxicity_freshwater",
            "toxicity_marine",
            "toxicity_terrestrial",
            "energy_resources",
            "eutrophication_freshwater",
            "eutrophication_marine",
            "human_toxicity_carcinogenic",
            "human_toxicity_non_carcinogenic",
            "ionising_radiation",
            "land_use",
            "material_resources",
            "ozone_depletion",
            "particulate_matter",
            "photochemical_oxidant_human_health",
            "photochemical_oxidant_terrestrial",
            "resource_scarcity",
          ].includes(x.key)
        );

  return { impactMethod, isLoading, environmentalCostMetric, indicators };
}
